import { useMediaQuery } from "@react-hook/media-query";
import React, { useEffect, useRef, useState } from "react";
import { Features } from "../Features";
import HRManagement from "../HRManagement";
import { HRmanage } from "../HRManagement/HrMobilemanage";
import { HRWrap } from "../HRManagement/style";
import { HowtoUse } from "../HowtoUse";
import { Scrollwrapper } from "../Scrollwrapper";
import Tymeplusmobile from "../TymepluMobile";
import { Home } from "./Home";
import HowtouseWrap from "../HowtoUse/style";
import Contactbanner from "../ContactBanner";
import { Feedback } from "../Feedback";
import EventForum from "../EventForum/EventForum";
import { useLocation } from "react-router-dom";

export const Homepage = ({ setColor, color, setScrollItem, headerRef }) => {
  console.log("coler1", color);
  const hrManagementRef = useRef(null);
  const featureRef = useRef(null);
  const homeRef = useRef(null);
  const howtouseRef = useRef(null);
  const [isHRManagementVisible, setIsHRManagementVisible] = useState(false);
  const [isFeatureVisible, setIsFeatureVisible] = useState(false);
  const [fadeIn, setFadeIn] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)");

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const timer = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          const headerHeight = headerRef?.current?.offsetHeight || 96;
          const buffer = 20; // extra breathing room below the header
          const elementTop =
            el.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementTop - (headerHeight + buffer),
            behavior: "smooth",
          });
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [location, headerRef]);
  useEffect(() => {
    const handleScroll = () => {
      const hrElement = hrManagementRef.current;
      const featureElement = featureRef.current;
      const homeElement = homeRef.current;

      console.log("scrolling", featureElement);

      if (hrElement && featureElement && homeElement) {
        const { top: hrTop, bottom: hrBottom } =
          hrElement.getBoundingClientRect();
        console.log("hrTop", hrTop, "hrBottom", hrBottom);
        const { top: featureTop, bottom: featureBottom } =
          featureElement.getBoundingClientRect();
        const halfScreenHeight = window.innerHeight / 2;
        const isFeatureVisible = featureTop < 200 && featureBottom >= 140;
        const isFeatureFadeIn = featureTop < 1000;
        setFadeIn(isFeatureFadeIn);

        const isHRManagementVisible =
          (hrTop < halfScreenHeight && hrBottom >= 160) ||
          (hrBottom > halfScreenHeight && hrTop <= halfScreenHeight);
        console.log("isHRManagementVisible", isHRManagementVisible);
        setIsHRManagementVisible(isHRManagementVisible);
        setIsFeatureVisible(isFeatureVisible);
        if (isFeatureVisible) {
          setIsHRManagementVisible(false);
        } else {
          setIsHRManagementVisible(isHRManagementVisible);
        }
        // Only control header color here; sections control `scrollItem`
        if (isFeatureVisible || isHRManagementVisible) {
          setScrollItem("features");
          setColor(true);
        } else {
          setColor(false);

          // Fallback: set `howtouse` active when its middle crosses the viewport center
          const howtoEl = howtouseRef.current;
          if (howtoEl && setScrollItem) {
            const { top: howtoTop, bottom: howtoBottom } =
              howtoEl.getBoundingClientRect();
            const center = window.innerHeight / 2;
            if (howtoTop < center && howtoBottom > center) {
              setScrollItem("howtouse");
            } else {
              setScrollItem("");
            }
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [setColor, setScrollItem]);

  const featureStyles = {
    position: isFeatureVisible || isHRManagementVisible ? "sticky" : "static",
    top:
      isFeatureVisible || isHRManagementVisible
        ? isMobile
          ? "50px"
          : "70px"
        : "auto",
    zIndex: isFeatureVisible || isHRManagementVisible ? "1000" : "auto",
    backgroundColor: isHRManagementVisible ? "white" : "#1f243b",
  };

  return (
    <div>
      <div ref={homeRef}>
        <Home setColor={setColor} />
      </div>

      <div style={featureStyles} className="py-4 my-0" id="Features">
        <HRWrap>
          <h3
            className="text4 underline contain-margin"
            style={{ color: isHRManagementVisible ? "#1F243B" : "white" }}
          >
            <span className="underline-text">Feat</span>ures
          </h3>
        </HRWrap>
      </div>
      <div ref={featureRef}>
        <Features
          setColor={setColor}
          isFeatureVisible={isFeatureVisible}
          isHRManagementVisible={isHRManagementVisible}
          fadeIn={fadeIn}
          setFadeIn={setFadeIn}
        />
      </div>
      <div ref={hrManagementRef}>
        <HRManagement
          isHRManagementVisible={isHRManagementVisible}
          setScrollItem={setScrollItem}
          setColor={setColor}
        />
      </div>
      <HRmanage />
      <div ref={howtouseRef}>
        <HowtoUse setScrollItem={setScrollItem} />
      </div>
      <Tymeplusmobile setScrollItem={setScrollItem} />
      <HowtouseWrap>
        <Contactbanner />
        <section id="Feedback">
          <div className="mt-4 pt-4">
            <Feedback />
          </div>
        </section>
      </HowtouseWrap>
      <Scrollwrapper />
      {/* <div id="event-forum">
        <EventForum />
      </div> */}
    </div>
  );
};
